/**
 * Poseidon dashboard — browser entry point.
 *
 * Served as a static asset by the Rust daemon at http://127.0.0.1:8000 alongside
 * the API it talks to, so it is same-origin by construction and needs no CORS.
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles.css';

const container = document.getElementById('root');

if (container === null) {
  // Nothing to render into: fail loudly rather than silently doing nothing.
  throw new Error('index.html is missing the #root element the dashboard mounts into.');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
